/* global TD */
import $ from "jquery";

var supportsMessage = "onmessage" in window;

function RecordPickerOpen(id, url) {
	var ctrl = $("#" + id);
	if(ctrl.is("SELECT")) {
		var opt = ctrl.prop("options");
		if(ctrl.prop("selectedIndex") != opt.length - 1)
			return;
		ctrl.prop("selectedIndex", opt.length - 2);
	}
	else if(ctrl.val() === "") {
		var s = ctrl.next().val();
		if(s !== "") 
			url += "&search=" + encodeURIComponent(s);
	}

	var frame = $("<iframe>", { name: "popup_" + id }), wrap = frame;

	if (/iPad|iPhone|iPod/.test(navigator.userAgent)) {
		wrap = $("<div>").append(frame);
	}

	wrap.appendTo(document.body);

	frame.attr("src", url);

	wrap.dialog({
		title: "Select Record",
		modal: true,
		autoOpen: true,
		closeText: "\u00D7",
		closeOnEscape: true,
		classes: { "ui-dialog": "ui-recordpicker td-embedded" },
		draggable: false,
		resizeable: false,
		open: function() {
			$("body").css("overflow", "hidden");
			$(this)
			.css({ width: "", height: "", "min-width": "", "min-height": "" })
			.dialog("widget")
			.css({ position: "", left: "", right: "", top: "", bottom: "", width: "", height: "" })
			.find(">.ui-dialog-titlebar>.ui-dialog-titlebar-close")[0].blur();
		},
		close: function() {
			$("body").css("overflow", "");
			$(this).dialog("destroy").remove();
		}
	});

	return false;
}

function RecordPickerClose(id) {
	var f = $(window.frames["popup_" + id].frameElement);
	var d = f.closest(".ui-dialog-content");
	d.dialog("close");
}

function RecordPickerSetValue(id, value, text) {

	this.close(id);

	var ctrl = $("#" + id);
	if(ctrl.is("select")) {
		var o, oo = ctrl.prop("options");
		for(var i = 1; i < oo.length - 1; i++) {
			var x = oo[i];
			if(x.value == value) {
				if(x.selected) return;
				o = x;
				break;
			}
		}
		(o || $("<option>", { value: value }).text(text).insertBefore(oo[oo.length - 1])).prop("selected", true);
		ctrl.trigger("change");
	}
	else if(ctrl.is("input")) {
		var n = ctrl.prop("name");
		var vel = ctrl.next();
		if(vel.is("SPAN.ui-helper-hidden-accessible"))
			vel = vel.next();
		if(vel.is("INPUT")) {
			vel.val(text);
			if(vel.attr("type") === "hidden") {
				vel = $("input[name=\"\"]", ctrl.prop("form"));
				$("#" + n + "_" + vel.prop("selectedIndex")).children("input[type=\"text\"]:first-child").val(text);
			}
		}
		if(ctrl.val() != value) {
			ctrl.val(value).trigger("change");
		}
	}
}

function RecordPickerSetResult(value, text) {
	var id = window.name;
	if(id.indexOf("popup_") === 0) {
		// IE9 can message strings only
		var msg = "WM_RECORDPICKERSETRESULT\n" + id.substring(6) + "\n" + value + "\n" + text;
		if(supportsMessage) {
			window.parent.postMessage(msg, "*");
		} else {
			window.parent.OnRecordPickerSetResultMessage({ data: msg });
		}
	}
}

function OnRecordPickerSetResultMessage(e) {
	var msg = e.data;
	if(typeof msg === "string") {
		msg = msg.split("\n");
		if(msg[0] === "WM_RECORDPICKERSETRESULT") {
			var id = msg[1];
			var value = msg[2];
			msg.splice(0, 3);
			var text = msg.join("\n");
			TD.RecordPicker.setValue(id, value, text);
		}
	}
}

if(!supportsMessage) {
	window.OnRecordPickerSetResultMessage = OnRecordPickerSetResultMessage;
}
else if(window.addEventListener) {
	window.addEventListener("message", OnRecordPickerSetResultMessage, false);
} else {
	window.attachEvent("onmessage", OnRecordPickerSetResultMessage);
}

export { RecordPickerOpen as open, RecordPickerClose as close, RecordPickerSetResult as setResult, RecordPickerSetValue as setValue };